module.exports = __webpack_public_path__ + "img/i1.dec7f03b.png";